import {
  ProductCreateRequestDto,
  ProductUpdateRequestDto,
  LocationResponseDto,
} from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';
import { getCreateProductPayload } from './getCreateProductPayload/getCreateProductPayload';
import { getUpdateProductPayload } from './getUpdateProductPayload/getUpdateProductPayload';
import { ProductFormState } from '../pages/hooks/useProductForm/types';

export const productPayloadBuilder = {
  create: (
    product: ProductCreateRequestDto,
    language: LanguagesType,
    locations: LocationResponseDto[],
  ) => getCreateProductPayload(product, language, locations),
  update: (
    originalProduct: ProductFormState,
    newProduct: ProductUpdateRequestDto,
    language: LanguagesType,
  ) => getUpdateProductPayload(originalProduct, newProduct, language),
  delete: (productId: string) => productId,
};
